import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import CategoryFilter from './CategoryFilter';
import { Category, useAnimationConfig } from '../../hooks';

interface CategoryFiltersProps {
  mainCategories: Category[];
  subCategories: Category[];
  selectedMainCategory: string;
  selectedSubCategory: string;
  showSubFilter: boolean;
  onMainCategorySelect: (category: string) => void;
  onSubCategorySelect: (category: string) => void;
}

const CategoryFilters: React.FC<CategoryFiltersProps> = ({
  mainCategories,
  subCategories,
  selectedMainCategory,
  selectedSubCategory,
  showSubFilter,
  onMainCategorySelect,
  onSubCategorySelect,
}) => {
  const { subFilterVariants } = useAnimationConfig();

  return (
    <>
      {/* Main Category Filter */}
      <div className="w-full flex flex-col items-center justify-center mb-2 mt-2">
        <CategoryFilter
          categories={mainCategories}
          selectedCategory={selectedMainCategory}
          onSelect={onMainCategorySelect}
          animated={true}
          show={true}
        />
      </div>

      {/* Sub Category Filter */}
      <div className="w-full flex flex-col items-center justify-center mb-6">
        <AnimatePresence mode="wait">
          {selectedMainCategory === 'all' && showSubFilter && (
            <motion.div
              key="sub-filter-slideup"
              variants={subFilterVariants.slideUp}
              initial="initial"
              animate="initial"
              exit="exit"
              style={{ width: '100%' }}
            >
              <CategoryFilter
                categories={subCategories}
                selectedCategory={selectedSubCategory}
                onSelect={onSubCategorySelect}
                animated={true}
                show={showSubFilter}
                minHeight="56px"
              />
            </motion.div>
          )}
          {selectedMainCategory !== 'all' && showSubFilter && (
            <motion.div
              key="sub-filter-container"
              initial={{ opacity: 1, y: 0 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30, transition: { duration: 0.25 } }}
              style={{ width: '100%' }}
            >
              <AnimatePresence mode="wait">
                <motion.div
                  key={selectedMainCategory}
                  variants={subFilterVariants.fade}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  style={{ width: '100%' }}
                >
                  <CategoryFilter
                    categories={subCategories}
                    selectedCategory={selectedSubCategory}
                    onSelect={onSubCategorySelect}
                    animated={true}
                    show={showSubFilter}
                    minHeight="56px"
                  />
                </motion.div>
              </AnimatePresence>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};

export default CategoryFilters;
